@if (showFooterCTA()) {
  <div class="footer-wrapper">
    <div class="footer-top content-wrapper">
      <div class="footer-top-content">
        <p class="footer-heading">LETS WORK TOGETHER</p>
        <p class="footer-subheading">
          Take the first step towards making your next project a success
        </p>
        <button class="footer-btn" (click)="onEstimateClick()">
          Estimate Project
        </button>

        <p class="footer-contact">
          Or call us now <span class="footer-phone">+919823994536</span>
        </p>
      </div>
    </div>
  </div>
}

<footer class="footer">
  <div class="content-wrapper">
    <div class="columns is-multiline">
      <div class="column is-4 is-3-desktop is-hidden-mobile">
        <div class="brand">
          <div class="brand-logo">
            <img
              src="/assets/logo/logo-dark.webp"
              alt="Geekeno Logo"
              class="logo"
              loading="lazy"
              height="149"
              width="422"
            />
          </div>
          <p>
            Driving business success with optimal effectiveness and efficiency.
          </p>
          <div class="social-icons">
            <a
              href="https://www.facebook.com/geekeno"
              target="_blank"
              aria-label="Geekeno on Facebook"
            >
              <fa-layers [fixedWidth]="true" size="2x">
                <fa-icon [icon]="icons.circle" [inverse]="true" />
                <fa-icon [icon]="icons.facebook" transform="shrink-6" />
              </fa-layers>
            </a>

            <a
              href="https://www.instagram.com/geek.eno/"
              target="_blank"
              aria-label="Geekeno on Instagram"
            >
              <fa-layers [fixedWidth]="true" size="2x">
                <fa-icon [icon]="icons.circle" [inverse]="true" />
                <fa-icon [icon]="icons.instagram" transform="shrink-6" />
              </fa-layers>
            </a>

            <a
              href="https://www.linkedin.com/company/geekeno/posts/?feedView=all"
              target="_blank"
              aria-label="Geekeno on LinkedIn"
            >
              <fa-layers [fixedWidth]="true" size="2x">
                <fa-icon [icon]="icons.circle" [inverse]="true" />
                <fa-icon [icon]="icons.linkedin" transform="shrink-6" />
              </fa-layers>
            </a>
          </div>
        </div>
      </div>
      <div class="services column is-4 is-offset-1-desktop is-hidden-mobile">
        <p class="title">Services</p>
        <ul>
          <li><a href="/services/digital-marketing">Digital Marketing</a></li>
          <li>
            <a href="/services/website-development">Website Development</a>
          </li>
          <li><a href="/services/graphic-designing">Graphic Designing</a></li>
          <li>
            <a href="/services/video-production">Video Production & Editing</a>
          </li>
        </ul>
        <p class="title">Products</p>
        <ul>
          <li><a href="/products/brand-kit">Brand Kit</a></li>
          <li><a href="/products/rekavoze">Rekavoze</a></li>
        </ul>
      </div>
      <div class="column is-4-desktop is-4-tablet">
        <p class="title">Get in Touch</p>
        <ul class="contact-info">
          <li>
            <a href="https://maps.app.goo.gl/NzVk8X1ierKFpRF79" target="_blank">
              <fa-icon [icon]="icons.address" />
              First Floor Le Chateau, Vasco Da Gama, Goa 403802
            </a>
          </li>
          <li>
            <a href="mailto:info@geekeno.com">
              <fa-icon [icon]="icons.email" /> info&#64;geekeno.com</a
            >
          </li>
          <li>
            <a href="tel:+919823994536">
              <fa-icon [icon]="icons.phone" /> +919823994536</a
            >
          </li>
          <li>
            <a href="/policies">
              <fa-icon [icon]="icons.policy" /> Policies & Terms</a
            >
          </li>
        </ul>
        <div class="social-icons is-hidden-tablet">
          <a
            href="https://www.facebook.com/geekeno"
            target="_blank"
            aria-label="Geekeno on Facebook"
          >
            <fa-layers [fixedWidth]="true" size="2x">
              <fa-icon [icon]="icons.circle" [inverse]="true" />
              <fa-icon [icon]="icons.facebook" transform="shrink-6" />
            </fa-layers>
          </a>

          <a
            href="https://www.instagram.com/geek.eno/"
            target="_blank"
            aria-label="Geekeno on Instagram"
          >
            <fa-layers [fixedWidth]="true" size="2x">
              <fa-icon [icon]="icons.circle" [inverse]="true" />
              <fa-icon [icon]="icons.instagram" transform="shrink-6" />
            </fa-layers>
          </a>

          <a
            href="https://www.linkedin.com/company/geekeno/posts/?feedView=all"
            target="_blank"
            aria-label="Geekeno on LinkedIn"
          >
            <fa-layers [fixedWidth]="true" size="2x">
              <fa-icon [icon]="icons.circle" [inverse]="true" />
              <fa-icon [icon]="icons.linkedin" transform="shrink-6" />
            </fa-layers>
          </a>
        </div>
      </div>
    </div>
  </div>
</footer>

<div class="whatsapp-link">
  <a
    href="https://wa.me/919823994536"
    target="_blank"
    aria-label="Contact us via WhatsApp"
  >
    <fa-layers size="4x">
      <fa-icon [icon]="icons.circle" />
      <fa-icon
        [icon]="icons.whatsapp"
        transform="shrink-6"
        [inverse]="true"
      /> </fa-layers
  ></a>
</div>
